import { api, apiFile, base_url_v1, base_url_v2 } from "./api";

export const UsersApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/users?${url_parms}`, method: "GET", token: true })
    return data;
}

export const SingleUserApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/users/${id}`, method: "GET", token: true })
    return data;
}

export const ListJobApi = async () => {
    const data = await api({ url: `${base_url_v2}company/jobs`, method: "GET", token: true })
    return data;
}

export const ListGroupJobApi = async () => {
    const data = await api({ url: `${base_url_v2}company/job-groups`, method: "GET", token: true })
    return data;
}

export const DetailForAddUserApi = async () => {
    let user = JSON.parse(String(localStorage.getItem('user')))
    const data = await api({ url: `${base_url_v2}company/companies/${user.user.company_id}`, method: "GET", token: true })
    return data;
}

export const DeleteUserApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/users/${id}`, method: "DELETE", token: true })
    return data;
}

export const AddUserApi = async (formRef: any ,cropData: any) => {
    let postData: any = {
        'username':formRef.current['username'].value,
        'first_name': formRef.current['name'].value,
        'last_name': formRef.current['family'].value,
        'password': formRef.current['password'].value,
        'status': formRef.current['status'].checked ? 1 : 0,
        'job_id': formRef.current['job'].value,
        'birthday': `${formRef.current['year'].value}-${formRef.current['month'].value}-${formRef.current['day'].value}`,
        'is_recognizable': formRef.current['tskePhoto'].checked ? 1 : 0,
        // 'IMEI': formRef.current['imei'].value,
        "avatar":  cropData != null ? cropData : ""
    }       
    const data = await api({ url: `${base_url_v2}company/users`, method: "POST", token: true, body: JSON.stringify(postData) })
    return data;
}

export const EditUserApi = async (formRef: any, detailData: any, isSelecetNewImage: boolean, cropData: any) => {
    let postData: any = {
        'first_name': formRef.current['name'].value,
        'last_name': formRef.current['family'].value,
        'password': formRef.current['password'].value,
        'status': formRef.current['status'].checked ? 1 : 0,
        'job_id': formRef.current['job'].value,
        'birthday': `${formRef.current['year'].value}-${formRef.current['month'].value}-${formRef.current['day'].value}`,
        'is_recognizable': formRef.current['tskePhoto'].checked ? 1 : 0,
        'IMEI': formRef.current['imei'].value,
        "avatar": isSelecetNewImage == true ? cropData : ""
    }
    const data = await api({ url: `${base_url_v2}company/users/${detailData.id}`, method: "PUT", token: true, body: JSON.stringify(postData) })
    return data;
}
